import BrickTitle from "@/components/landing/BrickTitle";

export default function Bonus() {
  return (
    <section id="bonus" className="py-16 bg-[#1B2229] border-y border-[#3A4752]" data-testid="bonus-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="bg-white rounded-2xl border-2 border-[#D4691E]/30 p-8 sm:p-10 shadow-sm relative overflow-hidden">
          <div className="absolute -right-8 -bottom-8 w-40 h-40 bg-[#D4691E]/10 rounded-full blur-2xl" />
          <div className="flex flex-col md:flex-row items-center gap-8 justify-between">
            <div className="min-w-0 w-full max-w-xl">
              <span className="inline-block px-3 py-1 rounded bg-[#D4691E] text-white text-xs font-bold uppercase tracking-wider mb-3">
                Client Bonus Included
              </span>
              <h3 className="text-2xl sm:text-3xl font-bold">
                <BrickTitle text="Complimentary 10-Point Home Health Inspection" />
              </h3>
              <p className="text-sm text-[#665E56] mt-3 leading-relaxed">
                When you book any repair job over 2 hours, you receive a free 10-point preventive check covering gutter
                runoff, pipe pressure joints, water heater relief valves, and electrical outlet safety. We spot minor
                faults before they become expensive emergency disasters.
              </p>
            </div>
            <div className="flex-shrink-0 text-center">
              <div className="w-24 h-24 rounded-full bg-[#FFF3EA] border-2 border-[#D4691E] flex flex-col items-center justify-center mx-auto mb-3">
                <span className="text-xs uppercase font-bold text-[#D4691E]">Value</span>
                <span className="text-2xl font-black text-[#1E252B]">$95</span>
                <span className="text-[10px] font-bold text-emerald-700">FREE</span>
              </div>
              <a
                href="#contact"
                data-testid="bonus-claim-btn"
                className="inline-block px-5 py-2.5 rounded bg-[#1E252B] hover:bg-[#D4691E] text-white text-xs font-bold uppercase tracking-wider transition-colors"
              >
                Claim With Quote
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
